import React, {useState,useEffect} from "react";
import NameLogo from '../images/NameLogo.png'
import {useSelector, useDispatch} from "react-redux"
import { selectUser, fetchUserAction } from 'src/stores/userSlice';
import axios from "axios";
import { notify } from '../utils/ToastUtils';
import { MyProfile } from "./MyProfile"
import { USProfile } from "./USProfile"
import Card from "src/components/Card";
import { ProfileSkeleton } from "../components/PageSkeletonLoaders";
import StepUpAuth from "../components/StepUpAuth";
import ApiClient from "../ApiClient";
// import utAvatar from "../images/utAvatar.png"

export const MyAccount = () => {
	const user = useSelector(selectUser)
	const dispatch = useDispatch()
	const [profile,setProfile] = useState({})
	const [country,setCountry] = useState('')
	const [profPic, setProfPic] = useState('')
	const [isLoading, setIsLoading] = useState(true)
	const [isUploadingImg, setIsUploadingImg] = useState(false)
	const [requiresStepUp, setRequiresStepUp] = useState(false)
	const [isCheckingAuth, setIsCheckingAuth] = useState(true)
	const DEFAULT_LOCATION = "India";

	// checkAuthStatus is no longer needed since backend enforces step-up

	const getMyDetails = async () =>{
		try{
			const {data} = await ApiClient.get(`${process.env.REACT_APP_BASE_URL}/user/profile`)
			setProfile(data[0])
			setCountry(data[0]?.EMP_COUNTRY)
			let img_path =  data[0]?.IMG_PATH ? `${process.env.REACT_APP_PUBLIC_URL}/${data[0]?.IMG_PATH}` :  `${process.env.REACT_APP_PUBLIC_URL}/public/img/utAvatar.png`
			setProfPic(img_path)
			setRequiresStepUp(false);
		}catch(error){
			console.log(error)
			if (error?.response?.data?.stepUpRequired) {
				setRequiresStepUp(true);
			} else {
				let errmsg = (error?.response) ? (error?.response?.data?.message ? error?.response?.data?.message : `${error?.response?.status} - ${error?.response?.statusText}`) : "Failed to load profile"
				notify.error(errmsg)
			}
		}finally{
			setIsLoading(false)
			setIsCheckingAuth(false)
		}
	}

	const openFileDialogBox = () => {
		let input = document.getElementById("imgDialogBox");
      	input.click();
	}

	const uploadImage = async (evt) => {
	 	var files = evt.target.files || evt.dataTransfer.files;
      	if (!files.length) return;
      	let formData = new FormData();
      	formData.append("file", files[0]);
		try{
			setIsUploadingImg(true);
			await axios.post(`${process.env.REACT_APP_BASE_URL}/bio/uploadImage`, formData, {
				headers: { "Content-Type": "multipart/form-data" },
			})		
			notify.success("Image uploaded successfully",{autoClose:3000})			
			await getMyDetails();
			dispatch(fetchUserAction());
		}catch(error){				
			let errmsg = (error?.response) ? (error?.response?.data?.message ? error?.response?.data?.message : `${error?.response?.status} - ${error?.response?.statusText}`) : "Something went wrong. Please try again later"
			notify.error(errmsg)
		}finally{
			setIsUploadingImg(false);
		}
	}

	const refreshProfile = async () => {
		setIsLoading(true);
		await getMyDetails();
		dispatch(fetchUserAction());
	}

	useEffect(()=>{
		setIsCheckingAuth(true);
		getMyDetails();
	},[])

	const handleStepUpVerified = () => {
		setRequiresStepUp(false);
		setIsLoading(true);
		getMyDetails();
	}

  return (
    <React.Fragment>
        <input
          type="file"
          name="images"
          id="imgDialogBox"
          style={{ display: "none" }}
          onChange={uploadImage}
          accept=".jpg, .jpeg, .png"
        />
        {isCheckingAuth ? (
            <ProfileSkeleton />
        ) : requiresStepUp ? (
			<StepUpAuth onVerified={handleStepUpVerified} />
		) : isLoading ? (
			<ProfileSkeleton />
		) : country?.toLowerCase() === DEFAULT_LOCATION?.toLowerCase() ? (
          <MyProfile onUploadImage={openFileDialogBox} profileData={profile} isUploadingImg={isUploadingImg} refreshProfile={refreshProfile} />
        ) : (
          <USProfile onUploadImage={openFileDialogBox} profileData={profile} isUploadingImg={isUploadingImg} refreshProfile={refreshProfile} />
        )}
    </React.Fragment>
  );
};
